import SpinnerModal from "../../oversight-core/ui-elements/spinner/spinner";
import styles from "./billing-summary-card.module.scss";

interface IProps {
  title: string;
  value: string | number;
  unit?: string;
  isLoading?: boolean;
}

const BillingSummaryCard = ({ title, value, unit, isLoading }: IProps) => {
  return (
    <div className={styles.summaryCard}>
      <div className={`font-size-14 text-light`}>{title}</div>
      <div className={`font-size-24 mt-1 text-dark ${styles.valueContainer}`}>
        {isLoading ? (
          <div className="mt-2">
            <SpinnerModal show={true} withOverlay={false} size="sm" />
          </div>
        ) : (
          <>
            <span className="font-weight-500">{value}</span>
            {unit && <span className="font-weight-400 ms-1">{unit}</span>}
          </>
        )}
      </div>
    </div>
  );
};

export default BillingSummaryCard;
